import moment from 'moment-timezone';

// PROD-7828 D4: when the teacher asked for a team-cancel, relative to session start. Mirrors the apis enum.
// Since 2026-10-07 the category is only ever derived from the request time (apis re-derives it); never hand-picked.
export const TEACHER_CANCEL_BUCKET_OPTIONS = [
  { value: 'OUTSIDE_24H', label: 'More than 24h before start' },
  { value: 'WITHIN_24_1H', label: '24h–1h before start' },
  { value: 'WITHIN_1H_OR_AFTER', label: 'Less than 1h before / after start' }
];

// Bucket from (session start − exact request time). Seconds-based >= so exact 24h/1h land in the earlier bucket, like the engine.
export function derive_cancel_bucket(session_start_epoch, requested_at_local, iana_timezone) {
  if (session_start_epoch === undefined || session_start_epoch === null || session_start_epoch === '') return '';
  const requested = moment.tz(requested_at_local, iana_timezone);
  if (!requested_at_local || !requested.isValid()) return '';
  const secs = moment(session_start_epoch).diff(requested, 'seconds');
  if (secs >= 24 * 3600) return 'OUTSIDE_24H';
  if (secs >= 3600) return 'WITHIN_24_1H';
  return 'WITHIN_1H_OR_AFTER';
}

// Mirrors apis: a request time more than 2 minutes past now is rejected (clock-skew tolerance).
export const REQUESTED_AT_CLOCK_SKEW_MS = 2 * 60 * 1000;
export const REQUESTED_AT_IN_FUTURE = "Requested at can't be in the future";

export function is_requested_at_in_future(requested_at_local, iana_timezone, now_ms) {
  const iso = requested_at_to_iso(requested_at_local, iana_timezone);
  return !!iso && moment(iso).valueOf() > now_ms + REQUESTED_AT_CLOCK_SKEW_MS;
}

// Plain-words category for a bucket ('' when none).
export function cancel_bucket_label(bucket) {
  const option = TEACHER_CANCEL_BUCKET_OPTIONS.find((o) => o.value === bucket);
  return option ? option.label : '';
}

// datetime-local value read in iana_timezone, as a UTC ISO string ('' when empty or malformed).
export function requested_at_to_iso(requested_at_local, iana_timezone) {
  if (!requested_at_local) return '';
  const m = moment.tz(requested_at_local, iana_timezone);
  return m.isValid() ? m.toISOString() : '';
}
